import React from 'react';

import { Typography } from '@occc-app/design-system';

export const ExternalFulfillment: React.FC = () => (
  <Typography>
    The Offer will be externally fulfilled by passing the appropriate offer id in the{' '}
    <strong>fulfilled_offer_ids</strong> array attribute of a transaction.
  </Typography>
);
